<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalTutorBillingBulkFlags } from '../../model/modal-tutor-billing-bulk-flags.hook'
import TutorBillingRecordChips from '../TutorBillingRecordChips.vue'
import TutorBillingTriStateSwitcher from '../TutorBillingTriStateSwitcher.vue'

defineOptions({
  name: 'ModalTutorBillingBulkFlags',
})

const {
  isOpen,
  isSaving,
  title,
  applyText,
  chips,
  isOverLimit,
  flags,
  labels,
  stateOptions,
  getValue,
  isValid,
  setFlag,
  setClose,
  setApply,
} = useModalTutorBillingBulkFlags()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    :title="title"
    description="Fields left as “Keep” are not changed. Everything else is applied to all selected records."
    class-name="modal-tutor-billing-bulk-flags"
    is-close-button
    @click:overlay="setClose"
    @click:close="setClose"
  >
    <TutorBillingRecordChips :chips="chips" />

    <AppText
      v-if="isOverLimit"
      name="body2"
      color="red-500"
      class="modal-tutor-billing-bulk-flags__hint"
    >
      Select up to 100 records
    </AppText>

    <AppText
      name="body2-medium"
      color="slate-700"
      class="modal-tutor-billing-bulk-flags__section-title"
    >
      Legal statuses
    </AppText>

    <div class="modal-tutor-billing-bulk-flags__card">
      <div
        v-for="flag in flags"
        :key="flag"
        class="modal-tutor-billing-bulk-flags__row"
      >
        <AppText
          name="body2"
          color="slate-900"
        >
          {{ labels[flag] }}
        </AppText>
        <TutorBillingTriStateSwitcher
          :value="getValue(flag)"
          :options="stateOptions"
          :label="labels[flag]"
          @change="setFlag(flag, $event)"
        />
      </div>
    </div>

    <template #controls>
      <BtnPrimary
        :text="applyText"
        :disabled="!isValid || isSaving"
        @click="setApply"
      />
      <BtnSecondary
        text="Cancel"
        :disabled="isSaving"
        @click="setClose"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalTutorBillingBulkFlags.scss" />
